import React from "react";
import {alpha, Box, Chip, Grid, List, ListItem, ListSubheader} from "@mui/material";
import PropTypes from "prop-types";

LabelList.propTypes = {
    labelsSets: PropTypes.array,
    labelFilter: PropTypes.func,
    selected: PropTypes.array,
    onChange: PropTypes.func
}

LabelList.defaultProps = {
    labelsSets: [],
    selected: [],
    onChange: () => null,
    labelFilter: () => true,
}

export default function LabelList({labelsSets, labelFilter, selected, onChange}) {

    const toggleSelect = (event, label) => {
        let elem = selected.find(sl => sl.id === label.id);
        if (elem) {
            if (event.ctrlKey)
                onChange(selected.filter(sl => sl.id !== label.id));
            else if (selected.length > 1)
                onChange([label]);
            else
                onChange([]);
        } else {
            if (event.ctrlKey)
                onChange([...selected, label]);
            else
                onChange([label]);
        }
    }

    const renderLabel = (label) => {
        const isSelected = Boolean(selected.find(sl => sl.id === label.id));
        return (
            <Chip
                size="small"
                variant="outlined"
                sx={{
                    "&.MuiChip-root": {
                        color: theme => isSelected
                            ? theme.palette.getContrastText(label.color)
                            : theme.palette.text.primary,
                        bgcolor: label.color
                            ? isSelected ? label.color : alpha(label.color, 0.2)
                            : "default",
                        borderColor: label.color
                            ? label.color
                            : "default",
                        ":hover": {
                            bgcolor: label.color
                                ? isSelected ? alpha(label.color, 0.6) : "default"
                                : "default",
                            borderRadius: "1em"
                        }
                    }
                }}
                label={label.label}
                onClick={(event) => toggleSelect(event, label)}
            />
        );
    }

    return (
        <Box
            sx={{
                flexGrow: 1,
                overflowY: "auto",
                overflowX: "hidden",
                position: "relative",
                width: "100%",
                height: "100%",
                minHeight: "200px"
            }}
        >
            <List
                sx={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    borderRadius: '0.3em',
                    overflow: 'auto',
                    bgcolor: theme => theme.palette.mode === "light" ? theme.palette.background.default : undefined,
                    '& ul': {padding: 0},
                }}
                subheader={<li/>}>
                {Array.isArray(labelsSets) && labelsSets.map((set) => (
                    <li key={`section-${set.id}`}>
                        <ul>
                            <ListSubheader>{`${set.name}`}</ListSubheader>
                            <ListItem key={`label-set-${set.id}`}>
                                <Grid container spacing={1} justifyContent={"space-evenly"}>
                                    {set.labels.filter(labelFilter).map(label => (
                                        <Grid item key={`label-list-item${label.id}`}>
                                            {renderLabel(label)}
                                        </Grid>
                                    ))}
                                </Grid>
                            </ListItem>
                        </ul>
                    </li>
                ))}
            </List>
        </Box>
    );
}